import React, { useEffect, useState } from 'react'

import { Alert, Loader } from '../components/ui-blocks'

import { ConsultantProfileEditor } from '../components/Profile'

import { getParsedFormData } from '../helpers'
import { getAvatar, getConsultantProfile, updateConsultantProfile } from '../helpers/consultdex-wp-api'

import { useUser } from '../contexts'


export const ProfileEditor = () => {
  const [profile, setProfile] = useState()
  const [error, setError] = useState(false)

  const { setUserAvatar } = useUser()


  useEffect(() => {

    getConsultantProfile()
      .then(results => {
        setProfile(results)
      })
      .catch(() => {
        setError(true)
      })

  }, [])


  const handleUpdate = async values => {
    const updatedValues = await updateConsultantProfile(getParsedFormData(values))

    setProfile(updatedValues)

    setUserAvatar(await getAvatar())
  }


  if (error) {
    return (
      <Alert variant="danger">
        We couldn't load your consultant profile. Your account may not have consultant
        access. Please contact support if this persists.
      </Alert>
    )
  }


  return (
    <>
      {!!profile ? (
        <ConsultantProfileEditor
          profile={profile}
          onUpdate={handleUpdate}
        />
      ) : (
          <Loader fullWidth />
        )}
    </>
  )
}
